function getDisplayRowIndex(rowIndex, vm) {
  return vm.headerChecked ? String(rowIndex + 2) : String(rowIndex + 1);
}

module.exports = getDisplayRowIndex;



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-import/vm-helpers/getDisplayRowIndex.js